var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.65,
    height: 34.19,
    viewBox: "0 0 33.65 34.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1378",
    "data-name": "Raggruppa 1378",
    transform: "translate(-178.242 -407.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8188",
    "data-name": "Tracciato 8188",
    d: "M4726.535,2253.05a2.948,2.948,0,1,0-2.948,2.948,2.952,2.952,0,0,0,2.948-2.948m-4.676,0a1.728,1.728,0,1,1,1.728,1.728,1.729,1.729,0,0,1-1.728-1.728",
    transform: "translate(-4528.521 -1836.585)",
    fill: "#555",
    stroke: "#555",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8187",
    "data-name": "Tracciato 8187",
    d: "M4683.467,2251.853l-4.338-14.361a.61.61,0,0,0-.458-.42l-4.319-.909a14.046,14.046,0,0,0,1.652-6.229,8.573,8.573,0,0,0-17.146,0,14.036,14.036,0,0,0,1.652,6.232l-4.319.909a.61.61,0,0,0-.458.42l-4.338,14.361a.609.609,0,0,0,.856.722l6.3-3.15,8.593,4.564a.61.61,0,0,0,.572,0l8.593-4.564,6.3,3.15a.61.61,0,0,0,.856-.722m-23.389-21.915a7.353,7.353,0,0,1,14.707,0v.014c.1,4.476-4,10-6.45,13.3-.334.451-.637.858-.9,1.227-.266-.369-.568-.776-.9-1.227-2.452-3.3-6.554-8.827-6.451-13.3Zm16.5,18.255a.61.61,0,0,0-.559.007l-8.584,4.56-8.584-4.56a.609.609,0,0,0-.559-.007l-5.317,2.658,3.825-12.66,4.293-.9a57.389,57.389,0,0,0,4.459,6.7c.47.633.876,1.18,1.2,1.644a.833.833,0,0,0,1.367,0c.324-.465.729-1.011,1.2-1.644a57.486,57.486,0,0,0,4.458-6.695l4.293.9,3.825,12.66Z",
    transform: "translate(-4472.365 -1813.293)",
    fill: "#555",
    stroke: "#555",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMap);
export default __webpack_public_path__ + "static/media/icon-map.73eed10a71895811fd053c790c9a9abf.svg";
export { ForwardRef as ReactComponent };